import { render, staticRenderFns } from "./FormBathroom.vue?vue&type=template&id=3b5c68e2&"
import script from "./FormBathroom.vue?vue&type=script&lang=js&"
export * from "./FormBathroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports